import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children, ...rest }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  return (
    <Route
      {...rest}
      render={() => (user ? children : <Redirect to="/auth/signin" />)}
    />
  );
};

export default PrivateRoute;
